import React, { FC } from "react";
import { IconButton, Flex } from "@evergis/ui";
import { GeometryType } from "@evergis/api";

import { TemplateFormActions, TemplateType } from "./TemplateFormActions";
import { TemplateFormContainer, TemplateActionButtons } from "../../../styled";
import { useTemplateForm } from "../../../hooks/useTemplateForm";
import { useCheckTemplateForm } from "../../../hooks/useCheckTemplateForm";
import { ModeEditorToggle } from "../../ModeEditorToggle";

export type GeometryTypeInfo = {
  geometryAttribute: string;
  geometryType: GeometryType;
};

type TemplateFormProps = {
  templateType: TemplateType;
  layerName: string;
  geometryTypeInfo: GeometryTypeInfo;
  handleSetTemplateValue: (value: string) => void;
  toggleTemplate: (type: string) => void;
  toggleMode: VoidFunction;
};

export const TemplateForm: FC<TemplateFormProps> = ({
  templateType,
  layerName,
  geometryTypeInfo,
  handleSetTemplateValue,
  toggleTemplate,
  toggleMode,
}) => {
  const { templateFormState, onChangeValue, onChangeAttribute, applyTemplateValue, clearForm } = useTemplateForm(
    templateType,
    handleSetTemplateValue,
    toggleTemplate,
  );

  const isValidForm = useCheckTemplateForm(templateType, templateFormState);

  return (
    <TemplateFormContainer>
      <TemplateFormActions
        templateType={templateType}
        layerName={layerName}
        templateFormState={templateFormState}
        onChangeValue={onChangeValue}
        onChangeAttribute={onChangeAttribute}
        geometryTypeInfo={geometryTypeInfo}
      />

      <TemplateActionButtons>
        <ModeEditorToggle fontSize={"0.625rem"} maxWidth={"7.625rem"} advancedMode={false} toggleMode={toggleMode} />
        <Flex style={{ justifyContent: "flex-end" }}>
          <IconButton kind={"close"} error onClick={clearForm} />
          <IconButton kind={"success"} primary disabled={!isValidForm} onClick={applyTemplateValue} />
        </Flex>
      </TemplateActionButtons>
    </TemplateFormContainer>
  );
};
